import React from 'react';
import { Provider } from 'react-redux';
import ContentIndex from './index';
import { createStore } from '../../stores/contentStore';

class ContentIndexRoot extends React.Component {
  constructor(props) {
    super(props);
    this.store = createStore(props.initialState);
  }

  render() {
    return (
      <Provider store={this.store}>
        <ContentIndex i18n={this.props.i18n} />
      </Provider>
    );
  }
}

export default ContentIndexRoot;
